import React, { Component } from 'react'
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import LeadReqHis from './LeadReqHis';
import EMReqHis from './EMReqHis';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

class ReqHistoryTabs extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: 0
        }
    }
    render() {

        const handleChange = (event, newValue) => {
            this.setState({ value: newValue })
        };

        return (
            <div>
                <AppBar position="static">
                    <Tabs
                        value={this.state.value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                    >
                        <Tab label="Request To LEAD" {...a11yProps(0)} />
                        <Tab label="Request To EM" {...a11yProps(1)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={this.state.value} index={0} >
                    <LeadReqHis value={this.props.value} uid={this.props.uid} />
                </TabPanel>
                <TabPanel value={this.state.value} index={1} >
                    <EMReqHis value={this.props.value} uid={this.props.uid} />
                </TabPanel>
            </div>
        )
    }
}

export default ReqHistoryTabs
